import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, HeartCrack } from "lucide-react";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const email = params.get("email") || "";
  const [status, setStatus] = useState("loading"); // loading | done | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!email) { setStatus("error"); setMessage("no email in the link"); return; }
    api.post("/unsubscribe", { email })
      .then((r) => {
        setStatus("done");
        setMessage(r?.data?.found ? "you're unsubscribed." : "no matching subscription, but you're all clear either way.");
      })
      .catch(() => { setStatus("error"); setMessage("something went wrong. try again in a minute."); });
  }, [email]);

  return (
    <div className="min-h-[calc(100vh-72px)] flex items-center justify-center px-6" data-testid="unsubscribe-page">
      <div className="max-w-md w-full bg-coal border border-white/10 p-10 text-center">
        {status === "loading" && (
          <>
            <p className="scribble text-hotpink text-xl">one sec</p>
            <p className="font-outfit text-white/60 mt-3">removing you from the list...</p>
          </>
        )}
        {status === "done" && (
          <>
            <div className="flex justify-center mb-4"><HeartCrack className="text-hotpink" size={48} /></div>
            <p className="scribble text-hotpink text-2xl rotate-[-2deg] inline-block">bye for now.</p>
            <h1 className="brush-title text-4xl md:text-5xl text-white mt-4">UNSUBSCRIBED.</h1>
            <p className="font-outfit text-white/70 mt-4">{message}</p>
            <p className="font-outfit text-white/40 text-sm mt-2 break-all">{email}</p>
            <Link to="/" data-testid="unsub-home-link" className="mt-8 inline-block bg-hotpink hover:bg-hotpink_dark text-white font-outfit font-extrabold uppercase tracking-widest text-xs px-6 py-3">
              back to the diary
            </Link>
          </>
        )}
        {status === "error" && (
          <>
            <p className="scribble text-hotpink text-2xl inline-block">oops.</p>
            <p className="font-outfit text-white/70 mt-4">{message}</p>
            <Link to="/" data-testid="unsub-home-link" className="mt-8 inline-block text-hotpink hover:underline font-outfit uppercase tracking-widest text-xs">back home</Link>
          </>
        )}
      </div>
    </div>
  );
}
